import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setPorkStables, setPorkStablesAdmin } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_PORK_STABLES } from "consts";

import { FootprintingPorkStablesPayload } from "models";

export const useMutateFootprintingPorkStables = (farmId: string, year: number, payload: FootprintingPorkStablesPayload, primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FOOTPRINTING_PORK_STABLES, primaryDataId, isAdmin],
    mutationFn: () => (isAdmin ? setPorkStablesAdmin(payload, primaryDataId) : setPorkStables(payload, primaryDataId)),
    onSuccess: async () => {
      invalidateAndRefecthQueries(queryClient, [
        [FOOTPRINTING_PORK_STABLES, primaryDataId, isAdmin],
        ...footprintingPorkPrimaryQueryKeys(primaryDataId, farmId, year, isAdmin),
      ]);
    },
  });
};
